import * as React from 'react';

function createMarkup(html) {
    return {
        __html: html
    };
}

export const Embed = ({ loading, html }) => {
    if (loading) {
        return (<div style={{ padding: 200 }}>
            <div className='ui active inverted dimmer'>
                <div className='ui massive text loader'>Loading</div>
            </div>
        </div>);
    }
    else if (!html) {
        return (<div className='container'><h2>404 Not Found</h2></div>);
    }
    else {
        return <div className='container' dangerouslySetInnerHTML={createMarkup(html)}></div>;
    }
};



// WEBPACK FOOTER //
// ./src/components/embed/embed.presentation.tsx